import { createSelector } from '@reduxjs/toolkit';

import { selectLookup } from '@/ducks/common/selectors';

export const selectQuickFindLinks = createSelector(selectLookup, ({ quickFindLinks }) =>
  [...(quickFindLinks ?? [])].sort((a, b) => +a.priority - +b.priority),
);

export const selectDisplayedQuickFindLinks = createSelector(selectQuickFindLinks, (quickFindLinks) =>
  quickFindLinks.filter(({ bookingFlowDisplay }) => bookingFlowDisplay && bookingFlowDisplay !== 'false'),
);

export const selectQuickFindLinkById = createSelector([selectQuickFindLinks, (state, id) => id], (quickFindLinks, id) =>
  quickFindLinks.find(({ quickFindId }) => quickFindId === id),
);
